import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const IconAlignLeft = (props?: SvgProps) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M14.0833 8.33333H3.25M17.4167 5H3.25M17.4167 11.6667H3.25M14.0833 15H3.25"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
